export default __webpack_public_path__ + "static/media/IQ.32a8a72f.svg";